module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAMtJREFUKFPVkb9KA2EQxGeukIOAz2NhZyNaCzYnwvFtaWeRd9DCLnwj9wSBe4W0eY3YWZgihSEcjFxILMIF0maLXZjlN+wfYhd1Xd8XRTElWe61gfrJvRgRre2ZpI8hoKqqUVmWS+6ca5LXAL4BfB0APwDGOedFRJgppV/bY5LrIWfbVyRHkh62QJ9yzv+jHUIppWcAlaSbcwZIvtqeAHg7aWmS7wDmtrUFuq67bJpmNXTWiHixfSvpru/3gGw/kbw48ocNgEdJbd//A+55fdGIb9bkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/icon_fz.png
// module id = aZQ/
// module chunks = 70